import PasswordInput from "components/input/PasswordInput";
import React, { Fragment, useState } from "react";

export default function NewPasswordInputs({
  newPassword,
  setNewPassword,
  confirmPassword,
  setConfirmPassword,
}) {
  const [errors, setErrors] = useState({
    newPassword: null,
    confirmPassword: null,
  });
  const errorMessage = "As senhas não são iguais";

  function disableErrorMessage(field) {
    if (errors[field]?.length > 0) {
      if (errors[field] === errorMessage) {
        errors.newPassword = null;
        errors.confirmPassword = null;
      } else errors[field] = null;
      setErrors({ ...errors });
    }
  }

  function checkPasswords() {
    if (newPassword !== confirmPassword) {
      setErrors({
        newPassword: errorMessage,
        confirmPassword: errorMessage,
      });
    } else if (confirmPassword?.length === 0) {
      setErrors({ confirmPassword: "A Senha parece ser inválida." });
    }
  }

  return (
    <Fragment>
      <PasswordInput
        placeholder="Nova Senha"
        error={errors?.newPassword}
        onChange={(text) => {
          setNewPassword(text);
          disableErrorMessage("newPassword");
        }}
      />
      <PasswordInput
        placeholder="Confirmar Nova Senha"
        error={errors?.confirmPassword}
        onBlur={checkPasswords}
        onChange={(text) => {
          setConfirmPassword(text);
          disableErrorMessage("confirmPassword");
        }}
      />
    </Fragment>
  );
}
